import {
  DP_DOCUMENTATION_LIST,
  DP_DOCUMENTATION_LIST_SUCCESS,
  DP_DOCUMENTATION_LIST_ERROR,
  DP_DOCUMENTATION_INVOICE_TEMPLATE_DATA,
  DP_DOCUMENTATION_INVOICE_TEMPLATE_DATA_SUCCESS,
  DP_DOCUMENTATION_INVOICE_TEMPLATE_DATA_ERROR,
  DP_DOCUMENTATION_SEND_INVOICE_EMAIL,
  DP_DOCUMENTATION_SEND_INVOICE_EMAIL_SUCCESS,
  DP_DOCUMENTATION_SEND_INVOICE_EMAIL_ERROR,
  DP_DOCUMENTATION_SEND_LETTERS_EMAIL,
  DP_DOCUMENTATION_SEND_LETTERS_EMAIL_SUCCESS,
  DP_DOCUMENTATION_SEND_LETTERS_EMAIL_ERROR
} from '../../actions';

const INIT_STATE = {
  documentationList: { loading: false, data: [], error: null },
  sendLetters: { loading: false, success: false, error: null, reference: null, sentTo: [], letters: [] },
  loading: false,
  data: [],
  accessoryComplementData: [],
  supplierEmailData: [],
  sentEmailInfo: null,
  sendEmail: { loading: false, success: false, error: null, sentTo: [], sentEmailInfo: null },
  error: null
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case DP_DOCUMENTATION_LIST:
      return { ...state, documentationList: { ...state.documentationList, loading: true, error: null } };
    case DP_DOCUMENTATION_LIST_SUCCESS:
      return {
        ...state,
        documentationList: { loading: false, data: action.payload.data || [], error: null }
      };
    case DP_DOCUMENTATION_LIST_ERROR:
      return {
        ...state,
        documentationList: { ...state.documentationList, loading: false, error: action.payload }
      };
    case DP_DOCUMENTATION_INVOICE_TEMPLATE_DATA:
      return {
        ...state,
        loading: true,
        error: null,
        sentEmailInfo: null,
        sendEmail: { loading: false, success: false, error: null, sentTo: [], sentEmailInfo: null }
      };
    case DP_DOCUMENTATION_INVOICE_TEMPLATE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.invoiceData || [],
        accessoryComplementData: action.payload.accessoryComplementData || [],
        supplierEmailData: action.payload.supplierEmailData || [],
        sentEmailInfo: action.payload.sentEmailInfo || null,
        sendEmail: state.sendEmail || INIT_STATE.sendEmail,
        error: null
      };
    case DP_DOCUMENTATION_INVOICE_TEMPLATE_DATA_ERROR:
      return { ...state, loading: false, error: action.payload };
    case DP_DOCUMENTATION_SEND_INVOICE_EMAIL:
      return { ...state, sendEmail: { loading: true, success: false, error: null, sentTo: [], sentEmailInfo: null } };
    case DP_DOCUMENTATION_SEND_INVOICE_EMAIL_SUCCESS:
      return {
        ...state,
        sendEmail: {
          loading: false,
          success: true,
          error: null,
          sentTo: action.payload.sent_to || [],
          sentEmailInfo: action.payload.sent_email_info || null
        },
        sentEmailInfo: action.payload.sent_email_info || null
      };
    case DP_DOCUMENTATION_SEND_INVOICE_EMAIL_ERROR:
      return {
        ...state,
        sendEmail: { loading: false, success: false, error: action.payload, sentTo: [], sentEmailInfo: null }
      };
    case DP_DOCUMENTATION_SEND_LETTERS_EMAIL:
      return {
        ...state,
        sendLetters: {
          loading: true,
          success: false,
          error: null,
          reference: action.payload.v_delivery_order_reference,
          sentTo: [],
          letters: []
        }
      };
    case DP_DOCUMENTATION_SEND_LETTERS_EMAIL_SUCCESS:
      return {
        ...state,
        sendLetters: {
          loading: false,
          success: true,
          error: null,
          reference: action.payload.reference,
          sentTo: action.payload.sent_to || [],
          letters: action.payload.letters || []
        }
      };
    case DP_DOCUMENTATION_SEND_LETTERS_EMAIL_ERROR:
      return {
        ...state,
        sendLetters: {
          loading: false,
          success: false,
          error: action.payload.error,
          reference: action.payload.reference,
          sentTo: [],
          letters: []
        }
      };
    default:
      return state;
  }
};
